import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { computed, onMounted, ref, watch } from 'vue'

import { TripFull } from '@/models/trip'

import { formatDateWithTime } from '@/helpers/date'
import { RbacAction, RbacEntity } from '@/helpers/rbac'

import { useTripsStore } from '@/store/trips'

import useScopeCheck from '@/composables/useScopeCheck'

import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LogsTab',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const comment = ref('')

const tripsStore = useTripsStore()

const allowedEditing = useScopeCheck(RbacAction.UPDATE, RbacEntity.TRIPS)

const listModule = computed(
  () => tripsStore.tripsLogs[props.trip.id]?.listModule
)
const creationModule = computed(
  () => tripsStore.tripsLogs[props.trip.id]?.creation
)

const list = computed(() => listModule.value?.list || [])
const error = computed(() => listModule.value?.error)
const isLoading = computed(() => listModule.value?.isLoading)
const isInitialLoadingDone = computed(
  () => listModule.value?.isInitialLoadingDone
)

const isCreatingComment = computed(() => !!creationModule.value?.isLoading)
const isCreationSuccess = computed(() => !!creationModule.value?.success)

watch(isCreationSuccess, newValue => {
  // Clear form on success
  if (newValue) comment.value = ''
})

const addComment = () => {
  tripsStore.createTripLog(props.trip.id, comment.value)
}

const getTripLogs = () => {
  tripsStore.getTripLogs(props.trip.id)
}

onMounted(() => {
  if (!isInitialLoadingDone.value && !isLoading.value) {
    getTripLogs()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (error.value)
    ? (_openBlock(), _createBlock(CommonError, {
        key: 0,
        errorMessage: error.value,
        onRetryPress: getTripLogs
      }, null, 8, ["errorMessage"]))
    : (!isInitialLoadingDone.value || (isLoading.value && !list.value.length))
      ? (_openBlock(), _createBlock(Loader, { key: 1 }))
      : (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 2,
          always: ""
        }, {
          default: _withCtx(() => [
            (_unref(allowedEditing))
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  class: "form-container"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "title" }, "Add comment", -1)),
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 4 },
                          placeholder: "Enter the comment",
                          resize: "vertical",
                          disabled: isCreatingComment.value,
                          modelValue: comment.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _createVNode(_component_el_button, {
                          plain: "",
                          size: "small",
                          type: "primary",
                          class: "add-btn",
                          disabled: !comment.value,
                          loading: isCreatingComment.value,
                          onClick: addComment
                        }, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode(" Add comment ")
                          ])),
                          _: 1,
                          __: [1]
                        }, 8, ["disabled", "loading"])
                      ]),
                      _: 1,
                      __: [2]
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "title" }, "Logs", -1)),
                    _createVNode(_component_el_timeline, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (tripLog) => {
                          return (_openBlock(), _createBlock(_component_el_timeline_item, {
                            placement: "top",
                            size: "large",
                            key: tripLog.id,
                            timestamp: _unref(formatDateWithTime)(tripLog.created_at)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tripLog.comment), 1)
                            ]),
                            _: 2
                          }, 1032, ["timestamp"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1,
                  __: [3]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}
}

})